module.exports = __webpack_public_path__ + "assets/images/scrolly-ageing/big.svg?v=df0710a1";